<template>
  <div class="row">
    <div class="col-4">
      <b-list-group>
        <b-list-group-item
          v-for="(item, idex) in items"
          :active="selected === idex"
          :key="item.id"
          @click="select(idex)"
          class="d-flex justify-content-between align-items-center"
        >
          <slot name="list" v-bind:item="item">{{
            item[itemDescription]
          }}</slot>
          <span
            v-if="enabledBadge && item.type == 3"
            class="badge badge-danger badge-pill"
            >end</span
          >
          <span
            v-if="enabledBadge && item.type == 1"
            class="badge badge-success badge-pill"
            >start</span
          >
        </b-list-group-item>
        <b-list-group-item class="p-0 py-2">
          <b-button variant="primary" block @click="doCreate">New</b-button>
        </b-list-group-item>
      </b-list-group>
    </div>
    <div v-if="showForm && hasItems" class="col-8" :key="selected_index">
      <div class="d-flex flex-row-reverse m-2">
        <b-button class="p-1" variant="danger" @click="remove"
          >Delete selected</b-button
        >
      </div>

      <slot
        name="edit"
        v-if="selected_index != null"
        v-bind:item="items[selected_index]"
      >
        {{ selected_index }}</slot
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "ItemsEditor",
  props: {
    items: { type: Array, default: null },
    enabledBadge: { type: Boolean, default: false },
    itemDescription: { type: String, default: "description" },
  },
  data() {
    return {
      selected: null,
      showForm: true,
    };
  },
  methods: {
    remove() {
      this.items.splice(this.selected, 1);
      this.$emit("input", this.items);
    },
    select(idex) {
      this.selected = idex;
      this.$emit("selection", idex);
    },
    doCreate() {
      this.showForm = true;
      this.$emit("create");
    },
  },
  computed: {
    hasItems() {
      if (this.items) {
        return this.items.length > 0;
      }
      return false;
    },
    total_items() {
      return (this.items || []).length;
    },
    selected_index() {
      if (this.selected === null) {
        if (this.total_items > 0) {
          this.selected = 0; // Auto Select First
        } else {
          return null;
        }
      }
      return this.selected || 0;
    },
  },
  watch: {
    items() {
      if (this.items.length <= 0) {
        this.showForm = false;
      }
    },
    total_items(newVal, oldVal) {
      if (newVal > oldVal || newVal < oldVal) {
        this.selected = newVal - 1; // select First One
      }
    },
  },
};
</script>

<style scoped></style>
